import styled from 'styled-components';
import {
  fontFamilyBold,
  fontFamilyBlack,
  header,
  text,
} from '../../../styling/mixins/typography';

export const StyledLogin = styled.div`
  h3 {
    ${header('h1')}
    margin-top: 26px;
    margin-bottom: 36px;
    text-transform: uppercase;
    ${fontFamilyBlack};
  }

  p {
    ${text('large')}
  }

  .form {
    margin-top: 2.4rem;
  }

  .input__wrapper {
    margin-bottom: 1.6rem;

    &:nth-child(2) {
      margin-bottom: 1.2rem;
    }
  }

  .submit {
    margin-top: 1.2rem;
  }

  .additional {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-top: 1.6rem;

    &__btn {
      text-decoration: underline;
    }
  }
`;
